export const urlConfig = {
  development: {
    plapi: "http://php-api.test1.fangzhibao.com/api",
    extapi: "http://extapi.test1.fangzhibao.com/v1",
    productionDetailUrl: "http://detail.test1.fangzhibao.com",
    main: "http://www.test1.fangzhibao.com",
    newMain: "http://seller.test1.fangzhibao.com",
    search: "http://search.test1.fangzhibao.com",
    member: "http://member.test1.fangzhibao.com",
    mainApi: "http://nodejs-api.test1.fangzhibao.com/v1",
    login: "http://login.test1.fangzhibao.com",
    user: "http://sc.test1.fangzhibao.com",
    erp: "http://fzb-erp.test1.fangzhibao.cn",
    qiniu: "http://qiniutest.fangzhibao.com",
    pages: "http://pages.test1.fangzhibao.com"
  },
  production: {
    plapi: "https://api-pl-mobile.fangzhibao.com/api",
    extapi: "https://extapi.fangzhibao.com/v1",
    productionDetailUrl: "https://detail.fangzhibao.com",
    main: "https://www.fangzhibao.com",
    newMain: "https://seller.fangzhibao.com",
    search: "https://search.fangzhibao.com",
    member: "https://member.fangzhibao.com",
    mainApi: "https://api.fangzhibao.com/v1",
    login: "https://login.fangzhibao.com",
    user: "https://sc.fangzhibao.com",
    erp: "https://erp.fangzhibao.cn",
    qiniu: "https://qiniu.fangzhibao.com",
    pages: "https://pages.fangzhibao.com"
  },
  // test1: {
  //   plapi: "http://php-api.test1.fangzhibao.com/api",
  //   extapi: "http://extapi.test1.fangzhibao.com/v1",
  //   productionDetailUrl: "http://detail.test1.fangzhibao.com",
  //   main: "http://www.test1.fangzhibao.com",
  //   newMain: "http://seller.test1.fangzhibao.com",
  //   search: "http://search.test1.fangzhibao.com",
  //   member: "http://member.test1.fangzhibao.com",
  //   mainApi: "http://nodejs-api.test1.fangzhibao.com/v1",
  //   login: "http://login.test1.fangzhibao.com",
  //   user: "http://sc.test1.fangzhibao.com",
  //   erp: "http://fzb-erp.test1.fangzhibao.cn",
  //   qiniu: "http://qiniutest.fangzhibao.com",
  //   pages: "http://pages.test1.fangzhibao.com"
  // },
  test2: {
    plapi: "https://php-api.test2.fangzhibao.com/api",
    extapi: "https://extapi.test2.fangzhibao.com/v1",
    productionDetailUrl: "https://detail.test2.fangzhibao.com",
    main: "https://www.test2.fangzhibao.com",
    search: "https://search.test2.fangzhibao.com",
    member: "https://member.test2.fangzhibao.com",
    mainApi: "https://nodejs-api.test2.fangzhibao.com/v1",
    login: "https://login.test2.fangzhibao.com",
    user: "https://sc.test2.fangzhibao.com",
    erp: "https://fzb-erp.test2.fangzhibao.cn",
    qiniu: "https://qiniutest.fangzhibao.com"
  },
  test3: {
    plapi: "http://php-api.test3.fangzhibao.com/api",
    extapi: "http://extapi.test3.fangzhibao.com/v1",
    productionDetailUrl: "http://detail.test3.fangzhibao.com",
    main: "http://www.test3.fangzhibao.com",
    search: "http://search.test3.fangzhibao.com",
    member: "http://member.test3.fangzhibao.com",
    mainApi: "http://nodejs-api.test3.fangzhibao.com/v1",
    login: "http://login.test3.fangzhibao.com",
    user: "http://sc.test3.fangzhibao.com",
    erp: "http://fzb-erp.test3.fangzhibao.cn",
    qiniu: "http://qiniutest.fangzhibao.com"
  },
  stage: {
    plapi: "http://php-api.stage.fangzhibao.com/api",
    extapi: "http://extapi.stage.fangzhibao.com/v1",
    productionDetailUrl: "http://detail.stage.fangzhibao.com",
    main: "http://www.stage.fangzhibao.com",
    search: "http://search.stage.fangzhibao.com",
    member: "http://member.stage.fangzhibao.com",
    mainApi: "http://node.stage-api.fangzhibao.com/v1",
    login: "http://login.stage.fangzhibao.com",
    user: "http://sc.stage.fangzhibao.com",
    erp: "http://fzb-erp.stage.fangzhibao.cn",
    qiniu: "http://qiniutest.fangzhibao.com"
  },
  test1: {
    plapi: "http://php-api.test1.fangzhibao.com/api",
    extapi: "http://extapi.test1.fangzhibao.com/v1",
    productionDetailUrl: "http://detail.test1.fangzhibao.com",
    main: "http://www.test1.fangzhibao.com",
    newMain: "http://seller.test1.fangzhibao.com",
    search: "http://search.test1.fangzhibao.com",
    member: "http://member.test1.fangzhibao.com",
    mainApi: "http://nodejs-api.test1.fangzhibao.com/v1",
    login: "http://login.test1.fangzhibao.com",
    user: "http://sc.test1.fangzhibao.com",
    erp: "http://fzb-erp.test1.fangzhibao.cn",
    qiniu: "http://qiniutest.fangzhibao.com",
    pages: "http://pages.test1.fangzhibao.com"
  }
};

export const APP_ENV = process.env.APP_ENV;

export const CurrentEnvPrefix = urlConfig[APP_ENV];



//////////////////
// WEBPACK FOOTER
// ./config/urlprefix.js
// module id = Kf48
// module chunks = 48